import { AutorisationAggregate } from '../../../../../aggregats/autorisation/autorisation.aggregate';
import { AutorisationsAggregate } from '../../../../../aggregats/autorisation/autorisations.aggregate';
import { SousMenuItemAggregate } from '../../../../../aggregats/menu/sous-menu-item.aggregate';
import { FonctionLogicielle } from '../../../../fonctions-logicielle-constantes';
import { EparcoursPath } from '../../eparcours-path';

export const profilsDroitsSousMenuItem = new SousMenuItemAggregate(
  'Profils et droits',
  `/${EparcoursPath.root.PROFILS_DROITS}`,
  new AutorisationsAggregate([new AutorisationAggregate(FonctionLogicielle.ProfilsDroits)]),
);

export const parametresSousMenuItem = new SousMenuItemAggregate(
  'Paramètres',
  '/parametres',
  new AutorisationsAggregate([
    new AutorisationAggregate(FonctionLogicielle.ParametresGeneraux),
    new AutorisationAggregate(FonctionLogicielle.ParametresEntite),
  ])
);

export const connecteursSousMenuItem = new SousMenuItemAggregate(
  'Connecteurs',
  '/connecteurs', // todo: à remplacer par la constante quand la page sera créée
  new AutorisationsAggregate([new AutorisationAggregate(FonctionLogicielle.Connecteurs)]),
);

export const entitesSousMenuItem = new SousMenuItemAggregate(
  'Entités',
  `/${EparcoursPath.root.ENTITES}`,
  new AutorisationsAggregate([new AutorisationAggregate(FonctionLogicielle.Entites)]),
);

export const personnelsSousMenuItem = new SousMenuItemAggregate(
    'Personnels',
    `/${EparcoursPath.root.PERSONNELS}`,
    new AutorisationsAggregate([new AutorisationAggregate(FonctionLogicielle.Personnels)]),
  );

export const automatisationsSousMenuItem = new SousMenuItemAggregate(
  'Automatisations',
  `/${EparcoursPath.root.E_PROCESS}`,
  new AutorisationsAggregate([new AutorisationAggregate(FonctionLogicielle.ParametresAutomatisations)]),
);